import React from 'react';

import { MaterialUiCore } from '@gscope-mfe/common-libs';

import classes from './BulkUpload.module.css';
import { Services, Utilities } from '@gscope-mfe/app-bridge';
import { loadI18n } from '../LocalizeLang';
import enData from './lang/en.json';
import esData from './lang/es.json';
import frData from './lang/fr.json';

const { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, TextField, Grid } = MaterialUiCore;
const { objArrayToCSV, cookies } = Utilities;
const { bulkUpload } = Services;

const BulkUpdate = ({ setBulkUpdate }) => {
    const [openModal, setOpenModal] = React.useState(false);
    const [description, setDescription] = React.useState('');
    const [resolveDesc, setResolveDesc] = React.useState(() => {});

    React.useEffect(() => {
        setBulkUpdate(() => {
            return invokeBulkUpdate;
        });
    }, []);

    async function invokeBulkUpdate({ serviceAction, serviceType, data }) {
        if (!data || data.length < 1) return;

        const description = await getUserComments();

        if (!description || description.length < 1) return;

        const csvData = objArrayToCSV(data);
        const uploadFromData = composeUploadFormData(csvData, serviceType, serviceAction, description);

        return bulkUpload(uploadFromData);
    }

    const composeUploadFormData = (csvData, serviceType, serviceAction, description) => {
        if (!csvData) return;

        const fileName = `${serviceType}_${serviceAction}.csv`;

        const csvBlob = new Blob([csvData], {
            type: 'text/csv;charset=utf-8',
        });
        const csvFile = new File([csvBlob], fileName);

        const formData = new FormData();
        formData.append('file', csvFile);
        formData.append('originalFile', csvFile);

        formData.append('fileId', fileName);
        formData.append(
            'payload',
            JSON.stringify({
                userId: cookies.get('loggedInUserName'),
                fileName: fileName,
                service: serviceType,
                serviceAction: serviceAction,
                uploadDesc: description,
                uploadType: 'bulkUpdate',
            }),
        );

        return formData;
    };

    const getUserComments = async () => {
        const descriptionPromise = new Promise((resolve) => {
            setResolveDesc(() => resolve);
        });
        setOpenModal(true);

        return descriptionPromise;
    };

    const confirmUpdate = () => {
        if (description && description.length) resolveDesc(description);
        else resolveDesc();

        setDescription('');
        setResolveDesc(() => {});
        setOpenModal(false);
    };

    const handleClose = () => {
        resolveDesc();
        setDescription('');
        setResolveDesc(() => {});
        setOpenModal(false);
    };

    const handleDescChange = (event) => {
        if (event.target.value) {
            if (event.target.value.length <= 60) setDescription(event.target.value);
        } else setDescription('');
    };

    return (
        <Grid>
            {openModal ? (
                <UpdateDialog
                    open={openModal}
                    handleClose={handleClose}
                    confirmUpdate={confirmUpdate}
                    description={description}
                    handleDescChange={handleDescChange}
                ></UpdateDialog>
            ) : null}
        </Grid>
    );
};

const UpdateDialog = ({ open, handleClose, confirmUpdate, description, handleDescChange }) => {
    const trans = loadI18n([
        ['en', enData],
        ['es', esData],
        ['fr', frData],
    ]);

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="update-dialog-title" id="update-comment-dialog">
            <DialogTitle id="update-dialog-title">{trans('bulkUpload.comments')}</DialogTitle>
            <DialogContent id="update-comment-dialog-content">
                <DialogContentText>{trans('bulkUpdate.commentDesc')}</DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="bulkUpdateDesc"
                    fullWidth
                    value={description}
                    required
                    onChange={(e) => handleDescChange(e)}
                    variant="outlined"
                    placeholder={trans('bulkUpload.description')}
                    helperText={`${description.length || 0}/60`}
                />
            </DialogContent>
            <DialogActions className="mb-2 mt-1">
                <button id="cancel-update" onClick={handleClose} className={`${classes.textOnlyBtn} mr-3`}>
                    {trans('bulkUpload.cancel')}
                </button>
                <button
                    id="confirm-update"
                    disabled={!description || description.length < 1}
                    onClick={confirmUpdate}
                    className={`${classes.primaryBtn} mr-3`}
                >
                    {trans('bulkUpdate.update')}
                </button>
            </DialogActions>
        </Dialog>
    );
};

export default BulkUpdate;
